export const BASE_URL = "https://api.esthell.com/";
